import { SSO_ERROR_MESSAGE } from "./sso-error-page.constant";

export const findNonExistingUserEmail = (error: string = "") => {
  const regexPattern = SSO_ERROR_MESSAGE.preSignupError.replace(
    "{{email}}",
    "([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})"
  );

  // Create a regex from the pattern
  const regex = new RegExp(`^${regexPattern}$`);

  // Match error with the generated regex
  const match = error.trim().match(regex);

  if (match) {
    return match[1];
  }

  return null;
};

export const isUserAccountDeactivated = (error: string = "") => {
  return error.trim() === SSO_ERROR_MESSAGE.deactivatedUserAccount;
};
